import React, { useState } from "react";
import Shipment from "./Shipment";
const AllShipments = () => {
  const [searchParams, setSearchParams] = useState({
    blNumber: "",
    status: "pending",
    page: 1,
    limit: 10,
    sort: { field: "eta", order: 1 },
  });
  const tableHeaders = [
    "BL Number",
    "Vessel Details",
    "SKU's",
    "Container Number",
    "Seal Number",
    "ETD(dd/mm/yyyy)",
    "ETA(dd/mm/yyyy)",
    "Unload Date(Approx)(dd/mm/yyyy)",
    "Status",
    "Add to Inventory",
  ];
  const header = "All Shipments";

  return (
    <Shipment
      searchParams={searchParams}
      completed={false}
      tableHeaders={tableHeaders}
      setSearchParams={setSearchParams}
      header={header}
    />
  );
};
export default AllShipments;
